import { CurrencyUsdOffIcon } from './CurrencyUsdOffIcon';

/**
 * author: Google
 * id 5E9D35E4-9487-4A9B-9D4B-E1BBCA52AE0C
 * name currency-usd-off
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-usd-off.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const MoneyOffIcon = CurrencyUsdOffIcon;
export default MoneyOffIcon